
<div class="container-fluid h-100 app-shell" >
  <app-loader></app-loader>
<mat-toolbar class="d-flex header  justify-content-between mat-toolbar" 
 >
  <div class="d-flex">      
    <div class="logo-frame">
      <img src="../assets/img/RockefellerLogowhitBackGround.svg" class="image" alt="Rockfeller logo" >
    </div>
    
   <div class="css-fzmnxl"></div>
    <div *ngIf="!isAdminRoute" class="fs-6 d-flex align-items-center header-title">SUPERVISION</div>
    <span *ngIf="showAdminLink && !isAdminRoute" class="header-divider">|</span>
    <a *ngIf="showAdminLink" routerLink="/admin" class="fs-6 d-flex align-items-center header-title pointer" [class.m-l-10]="isAdminRoute">Admin</a>

  </div>
  <div style="column-gap: 10px;" class="d-flex align-items-center">  
         
    <div *ngIf="!isAdminRoute" class="" style="display: flex;">
      <mat-icon  class="pointer m-r-10" inline="true"
        [matMenuTriggerFor]="advTreeMenu" #advMenuTrigger="matMenuTrigger">
        groups
      </mat-icon>
    </div>
    <span class="header-user-name fs-6">{{ loggedInUser?.name }}  </span>
   
    <mat-icon  *ngIf="showUserSel && !isAdminRoute" [matMenuTriggerFor]="superMenu"
      inline="true">more_vert</mat-icon>
    
  </div>
</mat-toolbar>
  <!-- Advsor Tree - menu-->
  <mat-menu #advTreeMenu="matMenu" class="advTree-menu">
    <ng-template matMenuContent>
      <div class="flex-col-container m-10" (click)="$event.stopPropagation()">
        <app-advisors-tree-filter *ngIf="advTree.length" [AdvisorsTreeData]="advTree" [SelectedRepIds]="repIds"
          (OnAppliedFilter)="advListChanged($event)" (cancelFilter)="closeAdvTree()">
        </app-advisors-tree-filter>
      </div>
    </ng-template>
  </mat-menu>
 
  <mat-menu  class=" min pe-3 ps-3 bg-white" #superMenu="matMenu" >
    <div class="" style="padding-bottom: 20px;"  (click)="$event.stopPropagation()">
      <mat-radio-group [(ngModel)]="tempRole" class=" " (click)="$event.stopPropagation()">
        <mat-radio-button value="SUPER" (click)="$event.stopPropagation()">SUPER</mat-radio-button>
        <mat-radio-button value="COMP" (click)="$event.stopPropagation()">COMPLIANCE</mat-radio-button>
        <mat-radio-button value="SUPERVISION" (click)="$event.stopPropagation()">SUPERVISION</mat-radio-button>
        <mat-radio-button value="AML" (click)="$event.stopPropagation()">AML</mat-radio-button>
        <mat-radio-button value="BM" (click)="$event.stopPropagation()">DS</mat-radio-button>
        <mat-radio-button value="HO"  (click)="$event.stopPropagation()">HO</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="menu-actions">
      <button  mat-stroked-button class="secondary"  >Cancel</button>
      <button   mat-flat-button class="primary "  (click)="changeUser()">Apply</button>
    </div>
  </mat-menu>
<div >
    <router-outlet  class="w3-animate w3-animate-right"></router-outlet>
</div>

</div>